export default __webpack_public_path__ + "static/media/bg.acfcbcf4.png";